import { createSelector } from 'reselect';
import { IUserState } from '../reducers/userReducer';
import { RootStore } from '../reducers/index';

export const userStateSelector = createSelector(
  (state: RootStore) => state.userState,
  (userState: IUserState) => userState,
);

export const userFirstNameSelector = createSelector(
  userStateSelector,
  (userState: IUserState) => userState.firstName,
);
